export default __webpack_public_path__ + "static/media/plain-sticker-m.e466d74c.png";